const PageURL = [
    { name: "Home", url: "/home" },
    { name: "About", url: "/about" },
    { name: "Experiences", url: "/experiences" },
    { name: "Contact", url: "/contact" },
  ];
export default PageURL;